<template>
  <v-container fluid class="tp-page">
    <template v-if="!addUser">
      <!-- Cabeçalho -->
      <div class="tp-page-head">
        <div>
          <h1 class="tp-page-title">Líderes de Rede</h1>
          <p class="tp-page-sub">{{ tabela.conteudo.length }} no total</p>
        </div>
        <div class="tp-head-actions">
          <v-text-field v-model="tabela.busca" prepend-inner-icon="mdi-magnify" placeholder="Buscar…" hide-details dense outlined color="#00695C" class="tp-search"></v-text-field>
        </div>
      </div>

      <!-- Tabela -->
      <v-card class="tp-card" elevation="0">
        <v-data-table :search="tabela.busca" :headers="tabela.cabecalho" :items="tabela.conteudo" sort-desc>
          <template v-slot:[`item.action`]="{ item }">
            <v-icon small color="#00695C" @click="editItem(item)">mdi-eye</v-icon>
          </template>
          <template v-slot:[`item.dataIntegracao`]="{ item }">
            <td>{{ transformaData(item.dataIntegracao, 'DD/MM/YYYY') }}</td>
          </template>
          <template v-slot:[`item.cor`]="{ item }">
            <v-card :color="item.cor">
              <p :style="`color:${item.cor}; margin: 0px`">{{ item.cor  }}</p>
            </v-card>
          </template>
          <template v-slot:no-data>
            <v-alert dense text outlined :value="true" color="warning" icon="info" class="ma-3">Nenhum divulgador encontrado</v-alert>
          </template>
          <template slot="no-results">
            <v-alert dense text outlined :value="true" color="warning" icon="info" class="ma-3">Sua pesquisa por "{{tabela.busca}}" não trouxe resultados</v-alert>
          </template>
        </v-data-table>
      </v-card>
    </template>

    <!-- CARD INSERE USUARIOS -->
    <v-card v-else class="tp-card tp-form" elevation="0">
      <template v-if="adicionarDivulgador">
        <v-card-title>
          <span class="tp-serif" style="font-size:1.25rem;color:#00253E;font-weight:600">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <p style="font-size:15px; color:#00695C"> *O preenchimento de todos os campos é obrigatório</p>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="4" md="4">
                <v-text-field v-model="editedItem.nome" outlined readonly label="Nome" color="#00695C"></v-text-field>
              </v-col>
              <v-col cols="12" sm="2" md="2">
                <v-text-field v-model="editedItem.cpf" outlined readonly label="CPF" v-mask="'###.###.###-##'" color="#00695C"></v-text-field>
              </v-col>
              <v-col cols="12" sm="2" md="2">
                <v-text-field v-model="editedItem.telefone" outlined readonly label="WhatsApp com DDD" color="#00695C" type="tel" v-mask="'(##) #####-####'"></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-text-field v-model="editedItem.email" outlined readonly label="Email" color="#00695C" type="email"></v-text-field>
              </v-col>
              <v-col cols="12" sm="2" md="2">
                <v-select v-model="editedItem.estadoCivil" :items="estadoCivil" outlined readonly label="Estado Civil" item-value="id" color="#00695C" type="estadoCivil"></v-select>
              </v-col>
              <v-col cols="12" sm="2" md="2">
                <v-text-field v-model="editedItem.dataNascimento" outlined readonly label="Data Nascimento" v-mask="'##/##/####'" color="#00695C" type="dataNascimento"></v-text-field>
              </v-col>
              <v-col cols="12" sm="2" md="2">
                <v-select v-model="editedItem.sexo" :items="sexo" outlined readonly label="Sexo" item-value="id" color="#00695C" type="sexo"></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        
        <v-card-title>
          <span class="tp-serif" style="font-size:1.25rem;color:#00253E;font-weight:600">{{ formTitle2 }}</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-container>
          <v-row>
            <v-col cols="12" sm="2" md="2">
              <v-select v-model="editedItem.tipo" :items="tipoMembro" outlined readonly label="Tipo" item-value="id" color="#00695C" type="tipo"></v-select>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-select v-model="editedItem.tipoIntegracao" :items="tipoIntegracao" outlined readonly label="Tipo Integracao" item-value="id" color="#00695C" type="tipointegracao"></v-select>
            </v-col>  
            <v-col cols="12" sm="2" md="2">
              <v-select v-model="editedItem.celula.redeId" outlined readonly label="Rede" @change="pegaCelulas" color="#00695C" :items="redes" item-text="nome" item-value="id"></v-select>
            </v-col>
             <v-col cols="12" sm="2" md="2">
              <v-select v-model="editedItem.celulaId" outlined readonly label="Célula" color="#00695C" :items="celulas" item-text="nome" item-value="id" @change="pegaLiderCelula"></v-select>
            </v-col>
            <!-- <v-col cols="12" sm="4" md="4">
              <v-text-field  v-model="editedItem.celula.lider" outlined readonly label="Nome do Líder" color="#00695C" hide-details></v-text-field>
            </v-col>        -->
          </v-row>
        </v-container>
        <v-card-actions class="px-4 pb-4">
          <v-spacer></v-spacer>
          <!-- <v-btn color="#00695C" class="cssBotao" dark large @click='save' >Salvar</v-btn> -->
          <v-btn color="#00695C" dark depressed rounded large class="tp-btn-add px-6" @click="close">Voltar</v-btn>
        </v-card-actions>
      </template>
    </v-card>
    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import moment from 'moment'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: { Snackbar, Loading },
    data: () => ({
      fullPage: true,
      isLoading: false,
      addUser: false,
      adicionarDivulgador: false,
      temInscritos: false,
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Nome', align: 'start', value: 'nome', },
          // { text: 'CPF', value: 'cpf' },
          { text: 'Data Nascimento', value: 'dataNascimento' },
          // { text: 'Estado Civil', value: 'estadoCivil' },
          // { text: 'Sexo', value: 'sexo' },
          { text: 'Telefone', value: 'telefone' },
          { text: 'Tipo', value: 'tipo' },
          // { text: 'Data Integração', value: 'dataIntegracao' },
          // { text: 'Tipo Integração', value: 'tipoIntegracao' },
          // { text: 'Célula', value: 'celula.nome' },
          // { text: 'Rede', value: 'celula.rede.nome' },
          // { text: 'Ações', value: 'action', align: 'center', sortable: false },
        ],
        conteudo: []
      },
      editedIndex: -1,
      editedItem: {
        nome: '',
        cpf: '',
        email: '',
        dataNascimento: '',
        estadoCivil: '',
        sexo: '',
        telefone: null,
        tipo: '',
        tipoIntegracao: '',
        redeId: '',
        lider: '',
        celulaId: '',
        celula: [],
      },
      defaultItem: {
        nome: '',
        cpf: '',  
        email: '',
        dataNascimento: '',
        estadoCivil: '',
        sexo: '',
        telefone: null,
        tipo: '',
        tipoIntegracao: '',
        redeId: '',
        lider: '',
        celulaId: '',
        celula: [],
      },
      sexo: ['MASCULINO', 'FEMININO'],
      estadoCivil: ['SOLTEIRO(A)', 'CASADO(A)', 'VIÚVO(A)', 'DIVORCIADO(A)', 'RELAÇÃO ESTÁVEL'],
      tipoMembro: ['CONGREGADO', 'MEMBRO', 'VISITANTE'],
      tipoIntegracao: ['ATRAVÉS DE BATISMO', 'VENHO DE OUTRA IGREJA'],
      eventos: [],
      eventoId: '',
      eventoIdAtual: '',
      redes: [],
      celulas: [],
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle() {
        return this.editedIndex === -1 ? 'ADICIONAR NOVO MEMBRO ' : 'EDITAR MEMBRO'
      },
      formTitle2() {
        return 'INFORMAÇÕES ECLESIÁSTICAS'
      }
    }),

    created() {
      if (this.user.tipo == 'ADMIN' || this.user.tipo == 'GERENTE' || this.user.tipo === 'BACKUP') {
        this.tabela.cabecalho.push({ text: 'Ações', value: 'action', align: 'center', sortable: false })
      }
      this.carregaRedes()
    },

    mounted() {
      this.carregaMembros()
    },

    watch: {
      //watch
    },

    methods: {
    async carregaMembros() {
  try {
    this.isLoading = true;

    let conditions = [];
    conditions.push({ "igrejaId": this.user.igrejaId });
    conditions.push({ "liderRede": true }); 

    if (this.user.tipo === 'LIDER') {
      conditions.push({ "celulaId": this.user.celulaId });
    }

    if (this.user.tipo === 'GERENTE') {
      conditions.push({ "recadastramento": true });
    }

    const filter = {
      where: {
        and: conditions
      },
      order: "nome ASC",
      include: [{ relation: "celula", scope: { include: ["rede"] } }]
    };

    await axios.get(baseApiUrl + `Membros?filter=${JSON.stringify(filter)}&access_token=${sessionStorage.getItem('accToken')}`)
      .then(response => {
        if (response.data) {
          if (this.user.tipo !== 'LIDER') {
            this.tabela.conteudo = response.data;
          }
          this.isLoading = false;
        } else {
          this.isLoading = false;
        }
      })
      .catch(() => {
        this.isLoading = false;
      });

    this.isLoading = false;

  } catch (error) {
    this.isLoading = false;
  }
},

      async carregaRedes() {
        try {
          const response = await axios.get(baseApiUrl + 'Redes?filter={"where":{"igrejaId":"' + this.user.igrejaId +'"}}&access_token=' + sessionStorage.getItem('accToken'))
          this.redes = response.data;
        } catch (error) {
          // console.error("Erro ao carregar redes:", error)
        }
      },

      async pegaCelulas() {
        if (this.editedItem.celula && this.editedItem.celula.redeId) {
          try {
            const responseCelulas = await axios.get(baseApiUrl + `Celulas?filter={"where":{"and":[{"igrejaId":"${this.user.igrejaId}","redeId":"${this.editedItem.celula.redeId}"}]}}&access_token=${sessionStorage.getItem('accToken')}`)
            this.celulas = responseCelulas.data;
            // console.log(this.celulas);
          } catch (error) {
            // console.error("Erro ao carregar células:", error)
         }
        } else {
          this.celulas = [];
        }
      },

      async pegaLiderCelula() {
        await axios.get(baseApiUrl + `Celulas/${this.editedItem.celulaId}?access_token=${sessionStorage.getItem('accToken')}`).then(response => {
          this.editedItem.celula = response.data
          this.editedItem.celulaId = response.data.id
          this.editedItem.celula.lider = response.data.lider
        })
      },

      editItem(item) {
        this.editedIndex = this.tabela.conteudo.indexOf(item);
        this.editedItem = Object.assign({}, item);

        if (!this.editedItem.celulaId) {
          this.editedItem.celula = this.editedItem.celula || {};
        } else {
          if (!this.editedItem.celula || !this.editedItem.celula.lider || !this.editedItem.celulaId) {
            this.pegaLiderCelula();
          } else {
            this.pegaCelulas()
          }
        }

        this.adicionarDivulgador = true
        this.addUser = true
      },

      criarNovo() {
        this.editedItem.celula = this.editedItem.celula || {}
        this.editedItem.celula.redeId = ''
        this.editedItem.celula.lider = ''
        this.adicionarDivulgador = true
        this.addUser = true
      },

      doCopy(id) {
        try {
          let copyText = document.getElementById(id);
          copyText.select();
          copyText.setSelectionRange(0, 99999); /* Para dispositivos móveis */
          document.execCommand("copy");
          this.snackbar = true
          this.textoSnackbar = 'Chave copiada para a área de transferência!'
        } catch (error) {
          this.snackbar = true
          this.textoSnackbar = 'Problema ao copiar chave para a área de transferência'
        }
      },

      compare(a) {
        // Use toUpperCase() to ignore character casing
        const dataA = moment(this.formatDateHora(a.fim), 'DD/MM/YYYY HH:mm:ss', true).format()
        //const dataB = new Date(moment(this.formatDatePadrao(b.fim)).format('YYYY-MM-DDTHH:mm:ss.000Z').replace('-03:00', 'Z'))
        const dataC = moment().format()
        let comparison = 0;
        if (dataC >= dataA) {
          comparison = 1;
        } else if (dataC < dataA) {
          comparison = -1;
        }
        return comparison;
      },

      formatDate(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDateBrz(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePadrao(date) {
        if (!date) return null

        const [day, month, year] = date.substr(0, 10).split('/')
        return `${year}-${month}-${day}` + " " + date.substr(11, 6)
      },

      formatDateHora(date) {
        if (!date) return null

        const [year, month, day] = date.substr(0, 10).split('-')
        return `${day}/${month}/${year}` + " " + date.substr(11, 8)
      },

      transformaData(data, formato) {
        let date = moment(data).format(formato);
        return date
      },

      async deleteItem(item) {
        var r = confirm('Deseja realmente excluir o membro ' + item.nome + '?')
        if (r == true) {
          this.isLoading = true
          await axios.delete(baseApiUrl + 'Membros/' + item.id + '?access_token=' + sessionStorage.getItem('accToken'))
          .then(() => {
            this.isLoading = false
            var vm = this
            vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
            this.carregaMembros()
          })
        }
      },

      close() {
        this.addUser = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      async save() {
        this.isLoading = true;
        const vm = this;
        if (
          this.editedItem.nome &&
          this.editedItem.cpf &&
          this.editedItem.sexo &&
          this.editedItem.dataNascimento &&
          this.editedItem.celula.redeId &&
          this.editedItem.email &&
          this.editedItem.telefone &&
          this.editedItem.estadoCivil &&
          this.editedItem.celulaId &&
          this.editedItem.tipo &&
          this.editedItem.tipoIntegracao
        ) {
          try {
            this.editedItem.igrejaId = this.user.igrejaId
            this.editedItem.redeId = this.editedItem.celula.redeId

            const response = this.editedIndex !== -1
            ? await axios.patch(`${baseApiUrl}Membros/${this.editedItem.id}?access_token=${sessionStorage.getItem('accToken')}`, this.editedItem)
            : await axios.post(`${baseApiUrl}Membros/replaceOrCreate?access_token=${sessionStorage.getItem('accToken')}`, this.editedItem);

            if (response.data != null) {
              vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO");
              this.carregaMembros();
              this.close();
            }
          } catch (error) {
            // console.error("Erro ao salvar membro:", error);
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO");
          }
        } else {
          this.isLoading = false;
          vm.$refs.chamaSnackbar.snack("#0288D1", "Preencha todos os campos!", "INFORMAÇÃO");
        }
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px;
    width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }
</style>
